import { render, staticRenderFns } from "./ResetearMesclada.vue?vue&type=template&id=b0229618&scoped=true"
import script from "./ResetearMesclada.vue?vue&type=script&lang=js"
export * from "./ResetearMesclada.vue?vue&type=script&lang=js"
import style0 from "./ResetearMesclada.vue?vue&type=style&index=0&id=b0229618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0229618",
  null
  
)

export default component.exports